import { DeleteOutlined, DollarOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Col, Dropdown, Row, Typography } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../helpers/date";
import { getUserType } from "../../../helpers/userDetails";
import CollectOpenInvoicePaymentModal from "../../Modals/CollectOpenInvoicePaymentModal";
import RevertInvoiceModal from "../../Modals/RevertInvoiceModal";
import CreateOrUpdatePromiseOnInvoiceModal from "../../Modals/CreateOrUpdatePromiseOnInvoiceModal";
import PromiseIcon from "./../../../assets/svgs/PromiseIcon.svg";
import PromisedTransactionIcon from "./../../../assets/svgs/PromisedTransactionIcon.svg";
import ThreeDotsVertical from "./../../../assets/svgs/ThreeDotsVertical.svg";
import ViewReceiptIconBlue from "./../../../assets/svgs/ViewReceiptIconBlue.svg";
import "./css/invoiceCard.css";

interface TransactionRowItemProp {
  label: string;
  value: string;
  valueClass: string;
  extraContainerClass?: string;
}
const DetailsItem: React.FC<TransactionRowItemProp> = ({
  label,
  value,
  valueClass,
  extraContainerClass = "",
}) => {
  return (
    <div className={`invoice-single-item-col ${extraContainerClass}`}>
      <Typography className="item-label">{label}</Typography>
      <Typography className={`${valueClass}`}>{value}</Typography>
    </div>
  );
};
const SingleConnectionInvoiceCard: React.FC<
  ConnectionSingleInvoiceCardProp
> = ({ invoice, reloadApi }) => {
  const [show, setShow] = useState<boolean>(false);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [showPromise, setShowPromise] = useState<boolean>(false);
  const navigate = useNavigate();
  const items: MenuProps["items"] = [];
  if (invoice.invoiceStatus === "OPEN") {
    items.push({
      key: "COLLECT_PAYMENT",
      label: (
        <Typography className="profile-drop-down-item">
          <DollarOutlined /> Collect Payment
        </Typography>
      ),
    });
    items.push({
      key: "CREATE_PROMISE",
      label: (
        <Typography className="profile-drop-down-item">
          <img src={PromiseIcon} />
          {invoice.promiseCreationDate !== null &&
          invoice.promiseCreationDate !== undefined
            ? "Update Promise"
            : "Create Promise"}
        </Typography>
      ),
    });
  }
  if (invoice.isInvoiceReverted === 0) {
    items.push({
      key: "REVERT_TRANSACTION",
      label: (
        <Typography className="profile-drop-down-item">
          <DeleteOutlined />
          Revert Transaction
        </Typography>
      ),
    });
  }

  const handleMenuClick = (e: any) => {
    switch (e.key) {
      case "COLLECT_PAYMENT":
        setShow(true);
        break;
      case "CREATE_PROMISE":
        setShowPromise(true);
        break;
      case "REVERT_TRANSACTION":
        setShowDelete(true);
        break;
    }
  };
  const handleClose = (isReload: boolean) => {
    setShow(false);
    setShowDelete(false);
    setShowPromise(false);
    if (isReload === true) {
      //lets reload the main api
      reloadApi();
    }
  };

  return (
    <>
      {show === true && (
        <CollectOpenInvoicePaymentModal
          handleClose={handleClose}
          show={show}
          invoice={invoice}
        />
      )}
      {showPromise === true && (
        <CreateOrUpdatePromiseOnInvoiceModal
          handleClose={handleClose}
          show={showPromise}
          invoice={invoice}
        />
      )}
      {showDelete === true && (
        <RevertInvoiceModal
          handleClose={handleClose}
          show={showDelete}
          invoice={invoice}
        />
      )}
      <Row
        style={{
          maxHeight: "200px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
        className="invoice-card-container"
        gutter={[16, 16]}
      >
        {invoice.promiseCreationDate !== null &&
          invoice.promiseCreationDate !== undefined &&
          Number(invoice.isPromiseFulfilled) !== 1 && (
            <img
              src={PromisedTransactionIcon}
              style={{
                maxWidth: "20px",
                marginLeft: "-19px",
                marginTop: "-20px",
                position: "absolute",
                zIndex: 1,
              }}
            />
          )}
        <Col span={4}>
          <DetailsItem
            label="Invoice Type"
            value={invoice.shortTitle}
            valueClass="payment-purpose"
          />
        </Col>

        <Col span={2}>
          <DetailsItem
            label="Status"
            value={invoice.invoiceStatus}
            valueClass="payment-purpose"
          />
        </Col>
        <Col span={2}>
          <DetailsItem
            label="Total Amount"
            value={`${invoice.invoiceTotalAmount}`}
            valueClass="user-name-label"
          />
        </Col>
        <Col span={2}>
          <DetailsItem
            label="Paid"
            value={`+${invoice.invoicePaidAmount}`}
            valueClass="in-amount-label"
            extraContainerClass="align-vertical-center"
          />
        </Col>

        <Col span={2}>
          <DetailsItem
            label="Discount"
            value={`-${invoice.invoiceDiscountAmount}`}
            valueClass="out-amount-label"
            extraContainerClass="align-vertical-center"
          />
        </Col>
        <Col span={3}>
          <DetailsItem
            label="Remaining"
            value={`${invoice.invoiceRemainingAmount}`}
            valueClass="user-name-label"
          />
        </Col>
        <Col span={4}>
          <DetailsItem
            label="Invoice Date"
            value={`${formatDate(new Date(invoice.invoiceCreatedAt))}`}
            valueClass="recharge-date-value"
          />
        </Col>

        <Col span={3}>
          <DetailsItem
            label="Staff"
            value={`${invoice.firstName} ${invoice.lastName}`}
            valueClass="user-name-label"
            // extraContainerClass="align-vertical-center"
          />
        </Col>

        <Col className="view-icons-container" span={2}>
          {/* <img
            className="cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              navigate(
                `/transactions/transaction-details/${invoice.intPkConnectionInvoiceID}/${invoice.isInvoiceReverted}`
              );
            }}
            src={ViewSoaIcon}
          /> */}
          {invoice.intPkConnectionInvoiceID && (
            <img
              onClick={(e) => {
                e.preventDefault();
                navigate(
                  `/receipts/receipt-details/${invoice.intPkConnectionInvoiceID}/${invoice.intPkConnectionID}`
                );
              }}
              className="cursor-pointer"
              src={ViewReceiptIconBlue}
            />
          )}
          {getUserType() === "CEO" && (
            <Dropdown
              menu={{
                items: items,
                onClick: handleMenuClick,
              }}
              placement="bottomRight"
            >
              <img
                onClick={(e) => {}}
                className="cursor-pointer"
                src={ThreeDotsVertical}
              />
            </Dropdown>
          )}
        </Col>
      </Row>
    </>
  );
};
export default SingleConnectionInvoiceCard;
